'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('promotionrequestEditCtrl', function ($scope, $rootScope, $window, $state, $http, $filter, $localStorage, $ngConfirm, apiSettings, MessageService, tools, model, productSegments, workflowApprovals, goals, targetAudiences, states, revenues, attachmentTypes, promotionRequestTypes, allowedFileExtensions, maxAllowedFileSize, PromotionRequest, WorkflowApproval, Goal, Customer, PromotionRequestRevenue, PromotionRequestType, Internal) {
	var vm = this;

	var $translate = $filter('translate');

	angular.extend($scope.$parent.vm, {
		title: 'promotionRequests.settings.titleNew',
		insertUrl: null
	});

	// INICIALIZAÇÕES
	$rootScope.laddaLoading = false;
	vm.model = model;
	vm.attachment = {}; // Inicializa a model que armazena as informações de um novo anexo
	vm.attachmentEditing = {}; // Inicializa a model que armazena as informações do anexo que está sendo editado
	vm.attachmentTypesActiveIndex = 0; // Inicializa o index da tab de anexos
	vm.isAttaching = false;
	vm.dateNow = new Date().toISOString().substr(0, 10);

	if (vm.model.isSelloutAction === undefined)
		vm.model.isSelloutAction = false; // Pré seleciona a opção Não

	if (vm.model.isProformaApproved === undefined && (vm.model.promotionRequestId === undefined || vm.model.promotionRequestId == 0)) // Para novas solicitações, seleciona como "Não" como padrão
		vm.model.isProformaApproved = false; // Pré seleciona a opção Não 

	// CONFIGURAÇÃO DO UPLOAD
	vm.tempFolder = tools.getRandomString(8);
	vm.uploadConfig = {
		singleFile: true,
		testChunks: false,
		target: apiSettings.baseUri + 'v1/internal/upload' + '?tempFolder=' + vm.tempFolder,
		headers: {
			'Authorization': 'Bearer ' + $localStorage.authorizationData.token
		}
	};
	vm.allowedFileExtensions = allowedFileExtensions.value.toLowerCase().split("|");
	vm.maxAllowedFileSize = parseInt(maxAllowedFileSize.value);

	// CONFIGURAÇÃO DO GRÁFICO
	vm.chartConfig = {
		cutoutPercentage: 50,
		responsive: true,
		tooltips: {
			enabled: false
		}
	};

	vm.chartColors = {
		backgroundColor: ['#0067B2', '#DDDDDD'],
		hoverBackgroundColor: ['#0067B2', '#DDDDDD'],
		hoverBorderColor: ['#FFFFFF', '#FFFFFF']
	};

	// LISTAS COMPLEMENTARES
	vm.productSegments = productSegments;
	vm.goals = goals;
	vm.targetAudiences = targetAudiences;
	vm.states = states;
	vm.cities = [];
	vm.workflowApprovals = workflowApprovals;
	vm.revenues = revenues;
	vm.attachmentTypes = attachmentTypes;
	vm.promotionRequestTypes = promotionRequestTypes || [];
	vm.selectedPromotionType = undefined;

	if (vm.model.promotionRequestTypeId) {
		for (var index = 0; index < vm.promotionRequestTypes.length; index++) {
			var element = vm.promotionRequestTypes[index];
			if (element.promotionRequestTypeId === vm.model.promotionRequestTypeId) {
				vm.selectedPromotionType = element;
				break;
			}
		}
	}

	// COMPUTEDS
	vm.isNewPromotionRequest = function () {
		return (vm.model.promotionRequestId === undefined || vm.model.promotionRequestId == 0);
	};

	vm.filterRevenueYTD = function () {
		return function (item) {
			return item.enumRevenueType == window.enumerators.revenueType.YTD;
		};
	};

	vm.filterRevenueFullYear = function () {
		return function (item) {
			return item.enumRevenueType == window.enumerators.revenueType.FullYear;
		};
	};

	vm.calcMarginAmount = function () {
		return vm.model.additionalRevenue * vm.model.margin / 100;
	};

	vm.calcRoi = function () {
		return vm.calcPercentage(vm.calcMarginAmount(), vm.model.investmentAmount);
	};

	vm.calcRevenuePercentYTD = function () {
		return vm.calcRevenuePercent(window.enumerators.revenueType.YTD);
	};

	vm.calcRevenuePercentFullYear = function () {
		return vm.calcRevenuePercent(window.enumerators.revenueType.FullYear);
	};

	vm.calcRevenuePercent = function (type) {
		var revenuesFiltered = vm.revenues.filter(function (item) {
			return (item.enumRevenueType == type);
		});

		var results = [];
		angular.forEach(revenuesFiltered, function (revenue, index) {
			if (vm.isProductSegmentChecked(revenue.productSegmentId))
				results.push(vm.calcPercentage(revenue.amount2, revenue.amount1));
		});

		return vm.calcAverage(results);
	};

	vm.calcAverage = function (values) {
		var sum = 0;
		for (var i = 0; i < values.length; i++) {
			sum += values[i];
		}
		return sum / values.length;
	};

	vm.calcPercentage = function (numerator, denominator) {
		return ((numerator / denominator) - 1) * 100;
	};

	vm.isAeroSelected = function () {
		return vm.isProductSegmentChecked(window.enumerators.productSegment.AERO);
	};

	vm.isArchSelected = function () {
		return vm.isProductSegmentChecked(window.enumerators.productSegment.ARCH);
	};

	vm.isProductSegmentChecked = function (productSegmentId) {
		if (productSegmentId && productSegmentId > 0) {
			return vm.model.productSegments ? vm.model.productSegments.indexOf(productSegmentId) > -1 : false; // Verifica se o segmento de produto passado no parâmetro está selecionado na solicitação
		}
		return true;
	};

	vm.getTitleRevenue = function (productSegmentId) {
		var title = "Faturamento";

		if (productSegmentId == window.enumerators.productSegment.AERO) {
			title = "Tubos"
		}
		else if (productSegmentId == window.enumerators.productSegment.ARCH) {
			title = "Galonagem"
		}

		return title;
	}

	vm.getLabelRevenue = function (type, productSegmentId, column) {
		var label;

		if (type == window.enumerators.revenueType.YTD) {

			switch (productSegmentId) {
				case window.enumerators.productSegment.AERO:
					label = "TUBOS";
					break;
				case window.enumerators.productSegment.ARCH:
					label = "GAL";
					break;
				default:
					label = "NET";
					break;
			}
			label += (column == 1 ? " BUDGET" : " ACTUAL");
		}
		else if (type == window.enumerators.revenueType.FullYear) {
			if (column == 1) {
				label = "Ano anterior";
			}
			else if (column == 2) {
				label = "Ano atual (estimativa BGT)"
			}
		}

		return label;
	}

	vm.revenueChartDataYTD = [100, 0];
	vm.getRevenueChartDataYTD = function () {
		return vm.getRevenueChartData(window.enumerators.revenueType.YTD);
	};

	vm.revenueChartDataFullYear = [100, 0];
	vm.getRevenueChartDataFullYear = function () {
		return vm.getRevenueChartData(window.enumerators.revenueType.FullYear);
	};

	vm.getRevenueChartData = function (type) {
		var percent = (type == window.enumerators.revenueType.YTD ? vm.calcRevenuePercentYTD() : vm.calcRevenuePercentFullYear());
		var data = (type == window.enumerators.revenueType.YTD ? vm.revenueChartDataYTD : vm.revenueChartDataFullYear);

		percent = (percent < 0 ? 0 : (percent > 100 ? 100 : percent)); //Limita o valor do gráfico a ficar entre 0 e 100%		
		data[0] = percent;
		data[1] = 100 - percent;
		return data;
	};

	// No caso de ser uma solicitação nova, as informações de faturamento são pré preenchidas com as informações da última solicitação do mesmo cliente
	vm.refreshRevenueInfoByCustomer = function (customerId) {
		PromotionRequestRevenue.listbycustomer({ customerId: customerId }).$promise.then(function (data) {
			vm.revenues = data;
		});
	};

	vm.refreshPromotionRequestsTypes = function () {
		PromotionRequestType.list({ isSellOut: vm.model.isSelloutAction }).$promise.then(function (result) {
			vm.promotionRequestTypes = result;
			vm.selectedPromotionType = undefined;
		}, function (response) {
			MessageService.alertError(response.data || response);
		});
	};

	vm.refreshCities = function () {
		// Limpa a lista de cidades, se não houver nenhum estado selecionado
		if (vm.model.stateId === undefined) {
			vm.cities = [];
			return;
		}

		// Carrega a lista de cidades do estado selecionado
		Internal.cities({ stateId: vm.model.stateId }).$promise.then(function (result) {
			vm.cities = result;
		}, function (response) {
			MessageService.alertError(response.data || response);
		});
	};

	// 2019-05-27: A funcionalidade de recuperar o Revenue de solicitações anteriores foi comentada por solicitação da equipe da Sherwin-Williams
	//$scope.$watch('vm.model.customer.id', function (newId, oldId) {
	//	if (vm.isNewPromotionRequest() == true) {
	//		if(newId && newId !== oldId) {
	//			vm.refreshRevenueInfoByCustomer(newId);
	//		}
	//	}
	//});

	$scope.$watch('vm.model.isSelloutAction', function (newValue, oldValue) {
		if (newValue !== oldValue) {
			vm.refreshPromotionRequestsTypes();
		}
	});

	$scope.$watch('vm.model.stateId', function (newValue, oldValue) {
		if (newValue !== oldValue) {
			vm.refreshCities();
			vm.model.stateId == undefined;
		}
	});

	vm.changePromotionRequestType = function () {
		vm.model.promotionRequestTypeId = vm.selectedPromotionType !== undefined ? vm.selectedPromotionType.promotionRequestTypeId : 0;
	};

	// AUTOCOMPLETE DE CLIENTES
	vm.getCustomers = function (val) {
		return Customer.listMinified({ pageSize: 50, keyword: val, customersTypeId: window.enumerators.customersTypes.Revenda }).$promise;
	};

	// UPLOAD DOS ANEXOS
	vm.initNewAttachment = function () {
		vm.attachment = {
			attachmentId: 0,
			attachmentTypeId: vm.getAttachmentTypeActive().attachmentTypeId,
			isDeleted: false,
			isEditing: false,
			requiredDbUpdate: true
		};
	};

	vm.showAttachmentForm = function (visible) {
		vm.isAttaching = visible;
		vm.initNewAttachment();

		// Reseta o formulário caso esteja fechando a modal de inclusão do anexo
		if (visible == false)
			vm.resetAttachmentForm();
	};

	vm.resetAttachmentForm = function () {
		var form = $scope.promotionrequestAttachmentForm;
		form.$setPristine();
		form.$setUntouched();
	};

	vm.getallowedFileExtensions = function () {
		return "." + vm.allowedFileExtensions.join(', .');
	};

	vm.getFileExtension = function (filename) {
		return tools.getFileExtension(filename);
	};

	vm.getAttachmentTypeActive = function () {
		return vm.attachmentTypes[vm.attachmentTypesActiveIndex];
	};

	vm.getAttachmentsByEnumType = function (type) {
		var type = vm.attachmentTypes.filter(function (item) {
			return (item.enumType == type);
		});

		if (!type || !type.length) return null;

		return type[0].attachments.filter(function (item) {
			return (item.isDeleted == false);
		});
	};

	vm.isAttachmentTypeInvoice = function () {
		return vm.getAttachmentTypeActive().enumType == window.enumerators.attachmentType.Invoice;
	};

	vm.editAttachment = function (item) {
		vm.showAttachmentForm(true);

		vm.attachmentEditing = item; //Guarda a referência do item que está sendo editado numa variável global, para que a mesma seja atualizada no caso do usuário clicar no botão salvar		
		angular.copy(vm.attachmentEditing, vm.attachment); //Atualiza a model de anexo com um cópia do objeto que está sendo editado
		vm.attachment.isEditing = true;
	};

	vm.deleteAttachment = function (item) {
		item.isDeleted = true;
		item.requiredDbUpdate = true;
	};

	vm.uploadSubmit = function ($files, $event, $flow) {
		if ($files[0] === undefined)
			return;

		// Valida se a extensão do arquivo é permitida
		if (tools.validateFileExtension($files[0].name, vm.allowedFileExtensions) == false)
			return;

		// Valida o tamanho do arquivo
		if (tools.validateFileMaxSize($files[0].size, vm.maxAllowedFileSize) == false)
			return;

		$flow.upload();
	};

	vm.uploadSuccess = function ($file, $message, $flow) {
		var uploadResult = JSON.parse($message);
		vm.attachment.name = uploadResult.originalFilename;
		vm.attachment.fileDocument = uploadResult.filename;
		vm.attachment.url = tools.getFileTempPath(vm.tempFolder, uploadResult.filename);

		// Reseta o flow
		$flow.cancel();
	};

	vm.uploadError = function ($file, $message, $flow) {
		MessageService.alertError($message);
	};

	vm.saveAttachment = function () {
		$rootScope.laddaLoading = true;

		vm.attachment.requiredDbUpdate = true;

		// Verifica se é uma inclusão ou edição do objeto
		if (vm.attachment.isEditing == true) {
			angular.copy(vm.attachment, vm.attachmentEditing); // Repassa as atualizações feitas na model do anexo, para o objeto de referência (anexo que está sendo editado)
		}
		else {
			vm.getAttachmentTypeActive().attachments.push(vm.attachment); // Inclui o novo objeto no array
		}

		vm.showAttachmentForm(false);

		$rootScope.laddaLoading = false;
	};

	vm.isTargetAudienceOtherSelected = function () {
		if (vm.model.targetAudienceId && vm.targetAudiences) {
			var targetAudience = vm.targetAudiences.rows.filter(function (item) {
				return (item.targetAudienceId == vm.model.targetAudienceId);
			});

			return (targetAudience && targetAudience[0].isOther == true);
		}

		return false;
	};

	// SALVAR
	vm.getLabelSaveButton = function () {
		return vm.isStatusDraft() == true ? "Enviar" : "Salvar";
	};

	vm.getLabelApprovalButton = function () {
		return vm.isInvoiceRequired() == true ? "Prosseguir" : "Aprovar";
	};

	vm.isStatusDraft = function () {
		return (vm.model.status === undefined || vm.model.status.isDraft == true);
	}

	vm.isStatusCompleted = function () {
		return (vm.model.status || vm.model.status.isCompleted == true);
	}

	vm.isInvoiceRequired = function () {
		return (vm.model.status && vm.model.status.isInvoiceRequired == true);
	}

	vm.isStatusCheckpoint = function () {
		return (vm.model.status && vm.model.status.isCheckpoint == true);
	}

	vm.isStatusMarginRequired = function () {
		return (vm.model.status && vm.model.status.isMarginRequired == true);
	}

	vm.editingEnabled = function () {
		// Habilita os campos do formulário para edição caso seja uma nova solicitação, ou estiver pendente de aprovação do usuário logado e estiver no status Em revisão
		return (vm.isNewPromotionRequest() == true || (vm.model.isRequiredToApproval == true && vm.isStatusDraft() == true));
	};

	vm.editingAttachmentsEnabled = function (type) {

		if (type.enumType == window.enumerators.attachmentType.PromotionProof) {
			// No caso dos anexos do Comprovação da Ação, habilita  a edição dos anexos caso seja uma nova solicitação, ou usuário logado tenha permissão para editar esse tipo de anexo, e caso esteja pendente de aprovação do usuário logado.
			return (vm.isNewPromotionRequest() == true || (type.permissionToEdit == true && vm.model.isRequiredToApproval == true));
		}
		else if (type.enumType == window.enumerators.attachmentType.Financial) {
			// No caso dos anexos do Financeiro, habilita a edição o usuário logado tenha permissão para editar esse tipo de anexo, e caso esteja pendente de aprovação do usuário logado.
			return (type.permissionToEdit == true && vm.model.isRequiredToApproval == true);
		}
		else {
			// Habilita a edição dos anexos caso seja uma nova solicitação, ou se o usuário logado foi quem criou a solicitação, e caso esteja pendente de aprovação do usuário logado.
			return (vm.isNewPromotionRequest() == true || (vm.model.isRequiredToApproval == true && vm.model.isOwner == true));
		}
	};

	vm.editingInvestmentValuesEnabled = function () {
		// Habilita os campos para edição do Investimento SW, Faturamento Adicional e da Margem:
		// - Caso seja uma nova solicitação, ou estiver pendente de aprovação do usuário logado e estiver no status Em revisão
		// - Ou se estiver pendente de aprovação do usuário logado caso seja o status imediatamente anterior tiver sido uma reprovação
		return vm.editingEnabled() == true || (vm.model.isRequiredToApproval == true && vm.model.previousWorkflowDisapproved == true);
	};

	vm.editingMarginEnabled = function () {
		// Habilita o campo para edição da Margem caso seja uma nova solicitação, ou estiver pendente de aprovação do usuário logado e estiver no status Em revisão ou Aprovação Gerência Regional
		return vm.editingEnabled() == true || vm.editingInvestmentValuesEnabled() == true || (vm.model.isRequiredToApproval == true && vm.isStatusMarginRequired() == true);
	};

	vm.approvalEnabled = function () {
		// Mostra as opções de aprovação/reprovação se for uma solicitação existente, estiver pendente de aprovação do usuário logado e NÃO estiver no status Em revisão
		return (vm.isNewPromotionRequest() == false && vm.model.isRequiredToApproval == true && vm.isStatusDraft() == false);
	};

	vm.saveEnabled = function () {
		// Habilita o botão salvar/enviar seja uma nova solicitação, ou se o usuário logado foi quem criou a solicitação, e caso esteja pendente de aprovação do usuário logado, e se estiver no status Em Revisão
		return (vm.isNewPromotionRequest() == true || (vm.model.isOwner == true && vm.model.isRequiredToApproval == true && vm.isStatusDraft() == true));
	};

	vm.approvalWithSaveEnabled = function () {
		// Retorna true caso esteja pendente de aprovação do usuário logado e 
		// Se estiver em algum status que é Checkpoint 
		// Ou no caso de estar no status Aprovação Gerência Regional, pois no gerente pode alterar a margem
		// Ou quando o usuário logado é do financeiro.
		// Ou quando status imediatamente anterior tiver sido uma reprovação
		return (vm.model.isRequiredToApproval == true && (vm.isStatusCheckpoint() == true || vm.isStatusMarginRequired() == true || vm.model.currentUserIsFinancialGroup == true || vm.model.previousWorkflowDisapproved == true))
	};

	vm.hasPromotionProofAttachmentsPending = function () {
		// Valida se existe algum documento de comprovação faltando. 
		//return (vm.getAttachmentsByEnumType(window.enumerators.attachmentType.PromotionProof).length == 0) || (vm.getAttachmentsByEnumType(window.enumerators.attachmentType.Invoice).length == 0) || (vm.getAttachmentsByEnumType(window.enumerators.attachmentType.AcquittanceDoc).length == 0);

		// Em Abr/2018 a SW solicitou que a nota fiscal não fosse mais obrigatória.
		return (vm.getAttachmentsByEnumType(window.enumerators.attachmentType.PromotionProof).length == 0) || (vm.getAttachmentsByEnumType(window.enumerators.attachmentType.AcquittanceDoc).length == 0);
	};

	vm.hasInvoiceAttachmentsPending = function () {
		// Valida se existe tem a Nota Fiscal anexada 	
		return (vm.getAttachmentsByEnumType(window.enumerators.attachmentType.Invoice).length == 0);
	};


	vm.validateForm = function () {
		// Verifica se algum segmento foi selecionado
		if (vm.model.productSegments === undefined || vm.model.productSegments.length == 0) {
			MessageService.alertInfo("É necessário selecionar ao menos um Segmento.");
			return false;
		}

		// Verifica se algum segmento foi selecionado
		if (vm.model.goals === undefined || vm.model.goals.length == 0) {
			MessageService.alertInfo("É necessário selecionar ao menos um Objetivo.");
			return false;
		}

		// Caso esteja no status Aprovação Gerência Regional, verifica se o usuário informou a margem
		if (vm.isStatusMarginRequired() == true && (!vm.model.margin || vm.model.margin == 0)) {
			MessageService.alertInfo("Para prosseguir, é necessário informar a Margem.");
			return false;
		}

		// Caso esteja no status Aprovação Gerência Regional, verifica se o cálculo do ROI é negativo
		//var roi = vm.calcRoi();
		//if (vm.isStatusMarginRequired() == true && (!roi || roi < 0)) {
		//	MessageService.alertInfo("Para prosseguir, o ROI não pode ser negativo.");
		//	return false;
		//}

		//var roi = vm.calcRoi();
		//if (vm.selectedPromotionType !== undefined && vm.selectedPromotionType.minimumRoi && vm.model.margin && (!roi || roi < vm.selectedPromotionType.minimumRoi)) {
		//	MessageService.alertInfo('Para o tipo de ação '+vm.selectedPromotionType.name+ ' o ROI calculado deve ser superior à '+vm.selectedPromotionType.minimumRoi+'%!');
		//	return false;
		//}

		// Caso tenha sido marcada a opção de solicitar análise do layout pelo Trade MKT, verifica se o usuário subiu anexos na aba material para criação
		if (vm.model.hasLayoutApproval == true && vm.getAttachmentsByEnumType(window.enumerators.attachmentType.Layout).length == 0) {
			MessageService.alertInfo("Para solicitar análise do layout pelo Trade, é necessário anexar o layout na aba Material para Crição.");
			return false;
		}

		// Caso tenha sido marcada a opção Sim em Ação de Sellout, verifica se o usuário subiu anexos na aba mecânica
		if (vm.model.isSelloutAction == true && vm.getAttachmentsByEnumType(window.enumerators.attachmentType.Mechanics).length == 0) {
			MessageService.alertInfo("Para ações de sellout, é necessário anexar a mecânica da ação na aba Mecânica.");
			return false;
		}

		// Caso esteja no status Comprovação da Ação, verifica se o usuário subiu anexos nas abas Comprovante da Ação, Nota Fiscal e Carta de Débito
		if (vm.isInvoiceRequired() == true && vm.hasPromotionProofAttachmentsPending() == true) {
			//MessageService.alertInfo("Para prosseguir, é necessário anexar o Comprovante da Ação, Nota Fiscal e a Carta de Débito.");
			MessageService.alertInfo("Para prosseguir, é necessário anexar o Comprovante da Ação e a Carta de Débito.");
			return false;
		}

		return true;
	};

	vm.validateComment = function (msg) {
		// Verifica se o comentário foi preenchido
		if (vm.model.comment == undefined || vm.model.comment == "") {
			MessageService.alertInfo(msg);
			return false;
		}
	};

	vm.save = function (enumStatusApproval) {
		// Validação do formulário
		if (vm.validateForm() == false)
			return;

		$rootScope.laddaLoading = true;

		// Atualiza a model com as listas de informações de faturamento e anexos
		vm.model.revenues = vm.revenues;
		vm.model.attachmentsTypes = vm.attachmentTypes;
		vm.model.tempFolder = vm.tempFolder;

		// Atualiza a model com o Id do cliente selecionado
		vm.model.customerId = vm.model.customer.id;

		// Caso seja uma nova solicitação ou esteja no status Em Revisão, já efetiva também a aprovação para o fluxo se mover
		if (vm.isNewPromotionRequest() || vm.isStatusDraft()) {
			enumStatusApproval = window.enumerators.statusApproval.Aprovado;
		}

		// Caso seja um Público-Alvo diferente "Outros", limpa a propriedade targetAudienceOther da model
		if (vm.isTargetAudienceOtherSelected() == false) {
			vm.model.targetAudienceOther = undefined;
		}

		// Caso exista o parâmetro de aprovação, complementa essa informação na model, para que seja feita também a movimentação do fluxo
		if (enumStatusApproval) {
			vm.model.workflowApprovalNext = vm.getWorkflowApprovalParameter(enumStatusApproval);
		}

		if (vm.isNewPromotionRequest()) {
			PromotionRequest.insert(vm.model, function () {
				$state.go('main.promotionrequest');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		} else {
			PromotionRequest.update(vm.model, function () {
				$state.go('main.promotionrequest');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		}
	};

	// APROVAÇÕES
	vm.getEnumStatusApprovalClass = function (item, icon) {
		switch (item.enumStatusApprovalId) {
			case window.enumerators.statusApproval.Aprovado:
				return icon ? "done" : "approved";
			case window.enumerators.statusApproval.Reprovado:
				return icon ? "highlight_off" : "disapproved";
			case window.enumerators.statusApproval.Cancelado:
				return icon ? "block" : "disapproved";
			default:
				return "";
		}
	};

	vm.approve = function () {
		// Validação do formulário
		if (vm.validateForm() == false)
			return;

		var messagePendingInvoce = (vm.isInvoiceRequired() == true && vm.hasInvoiceAttachmentsPending() == true) ? ", mesmo sem anexar a Nota Fiscal" : "";
		var message = "Deseja realmente " + (vm.isInvoiceRequired() ? "prosseguir com essa" : "aprovar essa") + " solicitação" + messagePendingInvoce + "?";

		MessageService.confirm(function () {
			// Verifica se está numa situação onde é necessário Salvar e também Aprovar, ou apenas Aprovar
			if (vm.approvalWithSaveEnabled() == false) {
				vm.doApproval(window.enumerators.statusApproval.Aprovado);
			}
			else {
				vm.save(window.enumerators.statusApproval.Aprovado);
			}
		},
			"Confirmação",
			message
		);
	};

	vm.disapprove = function () {
		// Verifica se o comentário foi preenchido
		if (vm.validateComment("Para prosseguir com a reprovação, é necessário preencher o motivo no campo de comentário.") == false)
			return;

		MessageService.confirm(function () {
			vm.doApproval(window.enumerators.statusApproval.Reprovado);
		},
			"Confirmação",
			"Deseja realmente reprovar essa solicitação?"
		);
	};

	vm.cancel = function () {
		// Verifica se o comentário foi preenchido
		if (vm.validateComment("Para prosseguir com o cancelamento, é necessário preencher o motivo no campo de comentário.") == false)
			return;

		MessageService.confirm(function () {
			vm.doCancel();
		},
			"Confirmação",
			"Deseja realmente cancelar essa solicitação?"
		);
	};

	vm.complete = function () {
		// Verifica se o comentário foi preenchido
		if (vm.validateComment("Para concluir com sucesso a solicitação, é necessário preencher o motivo no campo de comentário.") == false)
			return;

		MessageService.confirm(function () {
			vm.doComplete();
		},
			"Confirmação",
			"Deseja realmente concluir com sucesso essa solicitação?"
		);
	};

	vm.getWorkflowApprovalParameter = function (enumStatusApproval) {
		return {
			promotionRequestId: vm.model.promotionRequestId,
			enumStatusApproval: enumStatusApproval,
			comment: vm.model.comment
		};
	};

	vm.doApproval = function (enumStatusApproval) {
		$rootScope.laddaLoading = true;

		var params = vm.getWorkflowApprovalParameter(enumStatusApproval);

		WorkflowApproval.update(params, function () {
			$state.go('main.promotionrequest');
		}, function (response) {
			MessageService.alertError(response.data);
		});
	};

	vm.doCancel = function () {
		$rootScope.laddaLoading = true;

		var params = vm.getWorkflowApprovalParameter();

		WorkflowApproval.cancel(params, function () {
			$state.go('main.promotionrequest');
		}, function (response) {
			MessageService.alertError(response.data);
		});
	};

	vm.doComplete = function () {
		$rootScope.laddaLoading = true;

		var params = vm.getWorkflowApprovalParameter();

		WorkflowApproval.complete(params, function () {
			$state.go('main.promotionrequest');
		}, function (response) {
			MessageService.alertError(response.data);
		});
	};

	// Bind da cidade no carregamento inicial no caso de haver o estado selecionado
	if (vm.model.stateId !== undefined) {
		vm.refreshCities();
	}
});